import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import AvaliacaoDialog from '../components/AvaliacaoDialog';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mbdwlnnz';

const Contactos = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telemovel: '',
    assunto: '',
    mensagem: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (feedback.message) {
      setFeedback({ type: '', message: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    // Validação extra (HTML required já trata o básico)
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setFeedback({ type: 'error', message: 'Por favor insira um email válido.' });
      return;
    }

    setSubmitting(true);
    setFeedback({ type: '', message: '' });

    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome: formData.nome,
          email: formData.email,
          telemovel: formData.telemovel,
          assunto: formData.assunto,
          mensagem: formData.mensagem,
          _subject: `Contacto site Ultimate Fit: ${formData.assunto}`
        })
      });

      if (res.ok) {
        setFeedback({
          type: 'success',
          message: 'Mensagem enviada com sucesso! Entraremos em contacto em breve.'
        });
        setFormData({ nome: '', email: '', telemovel: '', assunto: '', mensagem: '' });
      } else {
        let detail = '';
        try {
          const data = await res.json();
          if (data && Array.isArray(data.errors) && data.errors.length) {
            detail = data.errors.map(err => err.message).join(' ');
          }
        } catch (_) { /* ignore */ }
        setFeedback({
          type: 'error',
          message: detail || 'Não foi possível enviar a mensagem. Tente novamente.'
        });
      }
    } catch (err) {
      setFeedback({
        type: 'error',
        message: 'Erro de ligação. Verifique a sua internet e tente novamente.'
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Header onOpenForm={() => setIsFormOpen(true)} />

      {/* Page Header */}
      <PageHeader 
        title="CONTACTOS"
        subtitle="Esclarece as tuas dúvidas. Fala connosco."
        backgroundImage="/assets/hero-background.webp"
      />

      {/* Secção Mapa + Info */}
      <section className="py-16 md:py-20 bg-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            
            {/* ESQUERDA - Mapa Google (B&W por defeito, cores no hover - desktop) */}
            <div className="w-full h-[400px] md:h-[500px] map-grayscale">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.2477886!2d-8.6261!3d40.8645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd23a265e0a8a0a9%3A0x0!2sRua%20Monsenhor%20Miguel%20de%20Oliveira%201366%2C%20Ovar!5e0!3m2!1sen!2spt!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Ultimate Fit"
              />
            </div>

            {/* DIREITA - Informações */}
            <div className="flex flex-col justify-center">
              {/* Título Principal */}
              <h2 
                className="text-5xl md:text-6xl lg:text-7xl uppercase mb-10"
                style={{ 
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontWeight: "normal",
                  letterSpacing: "0.02em",
                  lineHeight: "1"
                }}
              >
                VISITE-NOS
              </h2>

              {/* Horário de Funcionamento */}
              <div className="mb-8">
                <h3 
                  className="text-xl md:text-2xl uppercase mb-4"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    fontWeight: "bold",
                    letterSpacing: "0.05em"
                  }}
                >
                  HORÁRIO DE FUNCIONAMENTO
                </h3>
                <div 
                  className="text-base md:text-lg space-y-1"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.01em",
                    lineHeight: "1.6"
                  }}
                >
                  <p>Seg a Sexta: 7:00 — 21:00</p>
                  <p>Sáb: 8:00 — 13:00</p>
                  <p>Dom: 9:00 — 11:30</p>
                </div>
              </div>

              {/* Morada */}
              <div className="mb-8">
                <h3 
                  className="text-xl md:text-2xl uppercase mb-4"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    fontWeight: "bold",
                    letterSpacing: "0.05em"
                  }}
                >
                  MORADA
                </h3>
                <div 
                  className="text-base md:text-lg"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.01em",
                    lineHeight: "1.6"
                  }}
                >
                  <p>Rua Monsenhor Miguel de Oliveira 1366 – 1º andar</p>
                  <p>3880-796 Ovar, PT</p>
                </div>
              </div>

              {/* Contactos */}
              <div>
                <h3 
                  className="text-xl md:text-2xl uppercase mb-4"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    fontWeight: "bold",
                    letterSpacing: "0.05em"
                  }}
                >
                  CONTACTOS
                </h3>
                <div 
                  className="text-base md:text-lg"
                  style={{ 
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.01em",
                    lineHeight: "1.6"
                  }}
                >
                  <p>T: 920 627 943</p>
                  <p className="text-sm text-gray-600 mt-1">(custo de chamada para rede móvel nacional)</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Secção Formulário */}
      <section className="relative py-20 md:py-28 bg-black overflow-hidden">
        {/* Texto de fundo decorativo "CONTACTO" */}
        <div 
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          style={{ zIndex: 0 }}
        >
          <h2 
            className="text-[15rem] md:text-[20rem] lg:text-[25rem] uppercase text-white/5 leading-none select-none"
            style={{ 
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontWeight: "bold"
            }}
          >
            CONTACTO
          </h2>
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10">
          {/* Título */}
          <h2 
            className="text-4xl md:text-5xl lg:text-6xl text-white text-center uppercase mb-6"
            style={{ 
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontWeight: "normal",
              letterSpacing: "0.02em",
              lineHeight: "1.1"
            }}
          >
            ENVIE-NOS AS SUAS DÚVIDAS
          </h2>

          {/* Subtítulo */}
          <p 
            className="text-gray-300 text-center text-base md:text-lg mb-12 max-w-3xl mx-auto"
            style={{ 
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              letterSpacing: "0.01em",
              lineHeight: "1.6"
            }}
          >
            Estamos aqui para ajudar. Por favor, preencha o pequeno formulário abaixo e entraremos em contacto o mais breve possível.
          </p>

          {/* Formulário */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Primeira linha: Nome, Email, Telemóvel */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                placeholder="Nome *"
                required
                className="bg-transparent border border-white text-white px-4 py-4 focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-400"
                style={{ 
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "16px",
                  letterSpacing: "0.02em"
                }}
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email *"
                required
                className="bg-transparent border border-white text-white px-4 py-4 focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-400"
                style={{ 
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "16px",
                  letterSpacing: "0.02em"
                }}
              />
              <input
                type="tel"
                name="telemovel"
                value={formData.telemovel}
                onChange={handleInputChange}
                placeholder="Telemóvel"
                className="bg-transparent border border-white text-white px-4 py-4 focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-400"
                style={{ 
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "16px",
                  letterSpacing: "0.02em"
                }}
              />
            </div>

            {/* Assunto */}
            <input
              type="text"
              name="assunto"
              value={formData.assunto}
              onChange={handleInputChange}
              placeholder="Assunto *"
              required
              className="w-full bg-transparent border border-white text-white px-4 py-4 focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-400"
              style={{ 
                fontFamily: "'BebasNeue-Book', sans-serif",
                fontSize: "16px",
                letterSpacing: "0.02em"
              }}
            />

            {/* Mensagem */}
            <textarea
              name="mensagem"
              value={formData.mensagem}
              onChange={handleInputChange}
              placeholder="Mensagem *"
              required
              rows={6}
              className="w-full bg-transparent border border-white text-white px-4 py-4 focus:outline-none focus:border-yellow-400 transition-colors placeholder-gray-400 resize-none"
              style={{ 
                fontFamily: "'BebasNeue-Book', sans-serif",
                fontSize: "16px",
                letterSpacing: "0.02em"
              }}
            />

            {/* Botão Enviar + Feedback */}
            <div className="text-center pt-4">
              <Button
                type="submit"
                disabled={submitting}
                data-testid="contactos-submit-btn"
                className="bg-yellow-400 hover:bg-yellow-500 text-black uppercase px-12 py-6 transition-all hover:shadow-2xl disabled:opacity-60 disabled:cursor-not-allowed"
                style={{ 
                  fontFamily: "'BebasNeue-Book', sans-serif", 
                  fontWeight: "normal",
                  fontSize: "20px",
                  letterSpacing: "0.05em"
                }}
              >
                {submitting ? 'A ENVIAR...' : 'ENVIAR MENSAGEM'}
              </Button>

              {feedback.message && (
                <p
                  data-testid="contactos-feedback"
                  className={`text-sm mt-5 ${
                    feedback.type === 'success' ? 'text-yellow-400' : 'text-red-400'
                  }`}
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  {feedback.message}
                </p>
              )}
            </div>
          </form>
        </div>
      </section>

      <Footer />
      
      <AvaliacaoDialog 
        isOpen={isFormOpen} 
        onClose={() => setIsFormOpen(false)} 
      />
    </div>
  );
};

export default Contactos;
